class stickyBadge {
  _constructor() {
    this.$placeholder = document.querySelector('.badge-placeholder');
    this.$badge = document.querySelector('.badge-for-amounts');
  }

  _setPlaceholder() {
    const self = this;
    let height = self.$badge.clientHeight + 'px';
    self.$placeholder.style.height = height;
  }


  _stickyBadge() {
    const self = this;
    let resizeTimer;

    self._setPlaceholder();

    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        self._setPlaceholder();
      }, 250);
    });

    window.addEventListener('scroll', function() {
      let top = self.$placeholder.offsetTop;
      if( window.scrollY > top) {
        self.$badge.classList.add('sticky');
      } else {
        self.$badge.classList.remove('sticky');
      }
    });
  }

  init() {
    const self = this;
    this._constructor();
    // --

    self._stickyBadge();
  }
}

export default stickyBadge
